import { render, staticRenderFns } from "./MailLogsTable.vue?vue&type=template&id=52320322&"
import script from "./MailLogsTable.vue?vue&type=script&lang=js&"
export * from "./MailLogsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports